import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'
import {
  parseCsvCalendarDate,
  parseEnumEmptyString,
  parseStringArray,
} from '~/prix/utils/bulk/csvValueParsers'

const healthProfessional: Dataset = {
  schema: 'public_health',
  table: 'health_professional',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => (original != null ? Number(original) : null),
    cpf: original => original,
    cns: original => original,
    cbo: original => parseStringArray(original as string),
    cnes: original => parseStringArray(original as string),
    team_ine: original => parseStringArray(original as string),
    name: original => clearString(original as string),
    social_name: original => clearString(original as string),
    civil_name: original => clearString(original as string),
    sex: original => parseEnumEmptyString(original as string),
    birth_date: original => parseCsvCalendarDate(original as string),
    phone_number: original => clearString(original as string),
    street_name: original => clearString(original as string),
    street_number: original => original,
    complement: original => clearString(original as string),
    neighborhood: original => clearString(original as string),
    reference_point: original => clearString(original as string),
    postal_code: original => original,
    municipality: original => clearString(original as string),
    street_type: original => clearString(original as string),
    state: original => clearString(original as string),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default healthProfessional
